import { UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { FileExtensionPipe } from '@modules/attachments/pipes/file-extension.pipe';
import { AttachmentActionsService } from '@modules/attachments/services/attachment-actions.service';
import { Attachment } from '@shared/models/attachments/attachment';
import { MenuAction } from '@shared/models/menu-actions/menu-action';
import { MenuActionId } from '@shared/models/menu-actions/menu-action-id.enum';
import { TuiButton, TuiDialogContext } from '@taiga-ui/core';
import { POLYMORPHEUS_CONTEXT } from '@taiga-ui/polymorpheus';
import { FileIconComponent } from '../file-icon/file-icon.component';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'pxc-unsupported-attachment-preview',
  imports: [FileIconComponent, FileExtensionPipe, UpperCasePipe, TuiButton, TranslocoDirective],
  templateUrl: './unsupported-attachment-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      :host {
        display: block;
        background-color: black;
      }
    `,
  ],
})
export class UnsupportedAttachmentPreviewComponent {
  protected readonly context = inject<
    TuiDialogContext<
      void,
      {
        attachment: Attachment;
      }
    >
  >(POLYMORPHEUS_CONTEXT);

  @Input() attachment: Attachment = this.context.data?.attachment;

  private readonly attachmentActionsService = inject(AttachmentActionsService);

  get downloadAction(): MenuAction {
    return this.attachmentActionsService.getAction(MenuActionId.ATTACHMENT_DOWNLOAD);
  }
}
